// extracted by mini-css-extract-plugin
export default {"home":"Silhouette_home__j2wDn","logo":"Silhouette_logo__TcItz","form":"Silhouette_form__R0zab","acertou":"Silhouette_acertou__Zn3dd","downUp":"Silhouette_downUp__9cPHR"};